























import { Component } from 'vue-property-decorator'
import { Chart } from 'highcharts-vue'
import { BaseQuestion } from '@/components/Survey/QuestionTypes/BaseQuestion'
import {
  generateIndexSeries,
  generateSlicedSeries,
  getCategoriesForSlicedQuestion,
  getCategoriesForSlicedVariantQuestion,
  calcPercentage,
  Series,
  SeriesData,
  sortSingleSelectSeriesData
} from '@/components/Survey/Utilities/ChartUtilities'
import Tabs from '@/components/Tabs/Tabs.vue'
import Tab from '@/components/Tabs/Tab.vue'
import {
  getOptionsTextFromQuestion
} from '@/components/Survey/Utilities/SurveyUtilities'
import OpenEndsCard from '@/components/Survey/TextResponses/OpenEndsCard.vue'
import SliceNotSupported from '@/components/Survey/SliceNotSupported.vue'

@Component({
  components: {
    Highcharts: Chart,
    Tabs,
    Tab,
    OpenEndsCard,
    SliceNotSupported
  }
})
export default class SingleSelectQuestion extends BaseQuestion {
  readonly otherCategory: string[] = ['Other']

  get indexSeriesData () : SeriesData[] {
    return getOptionsTextFromQuestion(this.question).map(category => {
      return {
        name: category.text,
        y: calcPercentage(this.indexTotals[category.text], this.indexResponses.length)
      }
    })
  }

  get sortedIndexSeriesData () {
    return sortSingleSelectSeriesData(this.indexSeriesData, this.questionOptions, this.colorConfiguration.monochromatic)
  }

  slicedSeriesData () {
    const slicedSeriesData = generateSlicedSeries(this.segmentTotals, this.colorConfiguration.qualitativePalette, this.sortedCategories)

    const sortedData: Series[] = []
    this.sortedCategories.forEach(category => {
      const series = slicedSeriesData.find(o => o.name === category)
      if (series) {
        sortedData.push(series)
      }
    })

    return sortedData
  }

  get series () {
    if (this.isSliced || this.isVariant) {
      return this.slicedSeriesData()
    } else {
      return generateIndexSeries(this.sortedIndexSeriesData)
    }
  }

  get chartOptions () {
    return {
      ...this.defaultChartOptions(this.displayCategories),
      series: this.series,
      xAxis: {
        ...this.defaultChartOptions(this.displayCategories).xAxis,
        categories: this.displayCategories
      }
    }
  }

  get sortedCategories () {
    return this.sortedIndexSeriesData.map(data => data.name!)
  }

  get openEndSortedCategories () {
    if (this.question.hasExplainOpt) {
      return this.sortedCategories
    } else {
      return this.otherCategory
    }
  }

  get displayCategories () {
    if (this.isSliced && this.isVariant) {
      return getCategoriesForSlicedVariantQuestion(this.typedSlicedVariantResponses, this.selectedTab)
    } else if (this.isSliced || this.isVariant) {
      return getCategoriesForSlicedQuestion(this.segmentTotals, this.sliceByQuestion)
    } else {
      return this.sortedCategories
    }
  }

  get questionOptions () {
    return this.question!.options!
  }
}
